<template>
  <div class="graph-block">
    <div class="graph-block__header">
      <div>
        <h4>{{title}}</h4>
        <small v-if="tip"
          class="graph-block__tip">
            *{{tip}}
        </small>
      </div>
    </div>

    <div class="graph-block__graph-container">
      <div v-if="yAxis"
        class="graph-block__y-title">
          {{yAxis}}
      </div>
      <div v-if="xAxis"
        class="graph-block__x-title">
          {{xAxis}}
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    tip: {
      type: String,
      default: null
    },
    xAxis: {
      type: String,
      default: null
    },
    yAxis: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
  .graph-block {
    top: rem(20);
    left: rem(20);
    right: rem(20);
    bottom: rem(20);
    margin-top: 10px;

    h4 {
      margin-bottom: 10px;
    }

    small {
      color: color(grays, extra-light);
    }

    &__header {
      display: flex;
      flex: 0 0;
      width: 100%;
      align-items: center;
    }

    &__graph-container {
      flex: 1 1;
      height: calc(100% - 50px);
      position: relative;
      font-weight: bold;
      line-height: rem(13);
      padding-left: rem(25);
      padding-bottom: rem(20);
      font-size: rem(13);
      color: color(grays, light);
      text-transform: uppercase;
    }

    &__graph {
      height: calc(100% - 10px);
    }

    &__y-title {
      position: absolute;
      top: 50%;
      left: rem(-32);
      transform: rotate(-90deg);
    }

    &__x-title {
      bottom: 5px;
      right: 50%;
      position: absolute;
    }

    &__tip {
      line-height: rem(12);
    }
  }
</style>



// WEBPACK FOOTER //
// ChartLayout.vue?174bd6eb